<template>
	<div :style="{ height: bodyHeight + 'px' }" class="code-err qjc-relative">
		<div class="qjc-fts-36 qjc-texta-c qjc-absolute">
			<div class="zzc"></div>
			<vue-qr class="code" :text="$route.query.codeUrl" :logoSrc="require('@/assets/images/code_logo.png')" :margin='7' :correctLevel="3"></vue-qr>
			<p>当前二维码已失效，</p>
			<p>请重新扫描二维码进入~</p>
		</div>
	</div>
</template>

<script>
	import VueQr from 'vue-qr'
	
	export default{
		name: 'mCodeErr',
		data() {
			return {
				bodyHeight: document.documentElement.clientHeight,
				
				
			}
		},
		beforeCreate() {
			var codeUrl = this.$route.query.codeUrl;
			if(codeUrl){
				
			}else{
				history.back();
			}
		},
		components: {
			VueQr
		}
	}
</script>

<style lang="scss" scoped>
	.code-err{
		color: #535667;
		background-color: #F7F8FA;
		
		&>div{
			top: 50%;
			left: 50%;
			transform: translate(-50%,-50%);
			
			.code,
			.zzc{
				width: 4rem;
				height: 4rem;
				margin-bottom: 0.42rem;
			}
			.zzc{
				position: absolute;
				top: 0;
				left: 0;
				background-color: rgba(255,255,255,.8);
			}
			p{
				line-height: 0.48rem;
			}
		}
	}
</style>
